import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import { Alert, Modal, ListGroup } from 'react-bootstrap';
import Button from '../ui/Button';
import piction, { getUMOShareLink } from '../../utils/piction';
import Noty from 'noty';
import { SESSION_EXPIRED_MESSAGE } from '../../constants/sessionStateTypes';
import { sessionExpired } from '../../actions/session';
import Loader from '../ui/Loader';
import CopyableItem from './CopyableItem';

Noty.overrideDefaults({
  theme: 'bootstrap-v4',
  layout: 'center',
  closeWith: 'click',
  timeout: 3000,
  progressBar: false,
});

class UMOShareLinkView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      error: null,
      umo: null,
    };
    this.downloads = [];
    this.requestPromise = null;
    this.cancelRequest = this.cancelRequest.bind(this);
  }

  componentDidMount() {
    this.requestPromise = piction.getUMOs(`UMO_ID:"${this.props.data.umoID}"`, {
      ENABLE_LINK_CONTROL: 'T',
    })
      .then((res) => {
        if (res.umoList.all[0]) {
          const umo = res.umoList.all[0];
          this.setState({ umo, primaryID: this.props.data.umoID, isLoading: false });
        } else {
          this.setState({ error: 'No UMO returned', isLoading: false });
        }
      })
      .catch((err) => {
        if (err.message && err.message.includes(SESSION_EXPIRED_MESSAGE)) {
          this.props.dispatch(sessionExpired(err));
        }
        this.setState({ error: err, isLoading: false });
      });
  }

  componentWillUnmount() {
    this.cancelRequest();
  }

  cancelRequest() {
    if (this.requestPromise) {
      this.requestPromise.cancel();
    }
  }

  render() {
    const { intl } = this.props;
    let message = '';

    if (this.state.error) {
      message = (
        <Alert variant="danger" onDismiss={this.cancelRequest} >
          {this.state.error.message}
        </Alert>
      );
    }
    const downloads = this.state.umo && this.state.umo.originalList.all.map((downloadData, i) =>
      <li key={i}>
        <CopyableItem name={downloadData.name} text={downloadData.url} />
      </li>
    );

    return (
      <div className="share-view__modal">
        <div className="workspace-dialog__form-header">
          {intl.formatMessage({ id: 'mainDialog.title' })}
        </div>
        {this.state.isLoading ? <Loader className="umo-detail-view__loader" /> :
        <div>
          <div className="share-view__-header-sub">
            {intl.formatMessage({ id: 'mainDialog.subTitle' }, { umoName: this.state.umo.name })}
          </div>
          <br /><br />
          <div className="share-view__form">
            {message}
            <ul>{downloads}</ul>
          </div>
        </div>
        }
      </div>
    );
  }
}

UMOShareLinkView.propTypes = {
  data: PropTypes.instanceOf(Object),
  dispatch: PropTypes.func,
};

export default injectIntl(UMOShareLinkView);
